import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentList from '../AgentList/AgentList';
import EmailArchive from '../EmailArchive/EmailArchive';
import AgentView from '../Report/AgentView';
import WelcomeEmail from '../WelcomeEmail/WelcomeEmail';
import { IAdminDashboardProps } from './IAdminDashboardProps';
import { IAdminDashboardState } from './IAdminDashboardState';
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '500px',
    padding: '10px',
    minWidth: '200px'
});
const headerPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#35AFD1", color: "#FFFFFF", width: "100%", padding: "5px"
});
export default class AdminDashboard extends React.Component<IAdminDashboardProps, IAdminDashboardState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    constructor(props: IAdminDashboardProps, state: IAdminDashboardState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.state = {
            EmailId: this.props.EmailId,
            inputError: '',
            isValidData: false,
            loading: false,
            PatentCount: 0
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public render(): React.ReactElement<IAdminDashboardProps> {
        return (
            <div className={panel}>
                <div className={headerPanel}>
                    <h6>Welcome Admin</h6><h6>Your registered email address : {this.state.EmailId}</h6>
                </div>
                <div>
                    <Pivot>
                        <PivotItem headerText="Report" itemIcon={"ReportDocument"}>
                            <AgentView connectionContext={this.connectionContext} />
                        </PivotItem>
                        <PivotItem headerText="Agents" itemIcon={"ContactList"}>
                            <AgentList connectionContext={this.connectionContext} />
                        </PivotItem>
                        <PivotItem headerText="Invites" itemIcon={"ChatInviteFriend"}>
                            <WelcomeEmail connectionContext={this.connectionContext} />
                        </PivotItem>
                        <PivotItem headerText="Email Archive" itemIcon={"Archive"}>
                            <EmailArchive connectionContext={this.connectionContext} />
                        </PivotItem>
                    </Pivot>
                </div>

            </div>
        );
    }
}